var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.33333H6.75V4H8.5L11.4925 9.33333H15.5V4H17.25V9.33333H19V11.1111H17.25V12.8889H19V14.6667H17.25V20H15.5L12.4987 14.6667H8.5V20H6.75V14.6667H5V12.8889H6.75V11.1111H5V9.33333ZM8.5 9.33333H9.48875L8.5 7.58222V9.33333ZM8.5 11.1111V12.8889H11.4925L10.495 11.1111H8.5ZM15.5 16.4444V14.6667H14.4938L15.5 16.4444ZM12.49 11.1111L13.4963 12.8889H15.5V11.1111H12.49Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiNaira);
export default __webpack_public_path__ + "static/media/mdi_naira.578cd88d568ec70af6c3fff47c501e5f.svg";
export { ForwardRef as ReactComponent };